import { render, staticRenderFns } from "./waste.vue?vue&type=template&id=a0cdb7da&scoped=true&"
import script from "./waste.vue?vue&type=script&lang=js&"
export * from "./waste.vue?vue&type=script&lang=js&"
import style0 from "./waste.vue?vue&type=style&index=0&id=a0cdb7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cdb7da",
  null
  
)

export default component.exports